<template>
    <div>
        <section id="progress-bar-section" class="mobile-container bg-color-pink">
            <div class="bar">
                <div class="h-100 bg-page position-relative" :style="{width: percentages + '%'}">
                    <div class="text-center text-light font-weight-bold">{{ percentages }}%</div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: "ProgressBar",
    props: {
        percentages: {type: String, required: true},
    },
    data() {
        return {}
    },
}

</script>

<style scoped>
.bar {
    height: 30px;
    border: 2px solid #000000;
    border-radius: 3px;
    background-color: #ffffff;
}
</style>
